/** @format */

(function() {
	'use strict';

	angular.module('emsApp').config(localStorageConfig);

	localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

	function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
		$localStorageProvider.setKeyPrefix('jhi-');
		$sessionStorageProvider.setKeyPrefix('jhi-');
	}
})();
